import { useTranslation } from 'next-i18next'

import SVGImage from './Image/SVGImage'

export default function GemstoneProgress({
  outlineColor = 'black',
  score,
  innerClassName = '',
}: {
  outlineColor?: 'black' | 'white'
  score: number
  innerClassName?: string
}): React.ReactElement {
  const { t } = useTranslation(['generics', 'imageAlt'])

  const getOutlineOrGemstone = (threshold: number): { src: string; altText?: string } => {
    const gemstoneOutlineAsset: { src: string; altText?: string } =
      outlineColor === 'black'
        ? { src: 'misc/gemstone-outline-black.svg', altText: t('generics:emptyGem') }
        : { src: 'misc/gemstone-outline-white.svg', altText: t('imageAlt:icons.gemstoneOutlineWhite') }
    return score >= threshold
      ? { src: 'misc/gemstone-white.png', altText: t('generics:filledGem') }
      : gemstoneOutlineAsset
  }

  const Th1 = getOutlineOrGemstone(1)
  const Th3 = getOutlineOrGemstone(3)
  const Th2 = getOutlineOrGemstone(2)

  return (
    <div className={`${innerClassName}`}>
      <SVGImage alt={Th1.altText} imageClassName="w-4 h-4" srcKey={Th1.src} />
      <SVGImage alt={Th3.altText} imageClassName="w-5 h-5 mt-0.5" srcKey={Th3.src} />
      <SVGImage alt={Th2.altText} imageClassName="w-4 h-4" srcKey={Th2.src} />
    </div>
  )
}
